export const locale = {
  lang: 'en',
  data: {
    'CONTRO_ENCU': {
      'TIT_ENCABE':'Survey control',
      'CHAN_INFO':'Loading information',
      'TEX_INTRUCC':'* Perform search by selecting filter(s)',
      'SELEC_INSTI':'Institute',
      'SELEC_YEA':'Year',
      'SELEC_TI_ENC':'Products',
      'SELEC_ESTA':'Status',
      'BTN_FIL_INFO':'Filter Surveys',
      'COMFI_UPDA_TEX':'Are you sure to update?',
      'BTN_ACEP':'Accept',
      'BTN_CANC':'Cancel',
      'TEX_MOD_UPTD':'Updating',
      'TEX_SUCC_MOD_UPTD':'Upgraded successfully',
      'USE':'User:',
      'DAT':'Date:',
      'ACC':'Action:',
      'ACC_EVENT':{
      '0':'Deactivated',
      '1':'Enabled',
    },
      'NAM_TH':{
         'TH_NAM':'Company',
         'TH_TI_ENCU':'Survey type',
         'TH_DAT_APLI':'Application date',
         'TH_ESTA':'Status',
         'TH_TOKE':'Token',
         'TH_HC':'HC',
         'TH_RESPU':'Responses',
         'TH_DAT_CLO':'Closing date',
         'TH_PRORR':'Rollover',
         'TH_REPO_EXC':'Excel report',
         'TH_ONLI':'Online',
         'TH_OFFLI':'Offline',
         'TH_AUDIT':'Audit',
         'TH_SECT':'Sector',
         'TH_SUBSECT':'Sub sector',
         'TH_LIPROY':'Project Leader',
         'TH_JEFPROY':'Project leader',
      }
    },

  }
};
